module.exports = __webpack_public_path__ + "static/media/ic_save.3e9d443c.svg";